import * as React from "react";
import * as H from "history";
import PubSub from 'pubsub-js';
import { AuthService } from "../auth/auth-service";
import { NavLink } from "react-router-dom";
import { dialogService } from "react-api-dialog";
import { LanguageMenu } from "./Language";
import t from "../i18n";
import { LoginWithAnalytics, RegisterWithAnalytics } from "../auth";
import { createHashHistory } from "history";
import { DesktopMenu } from "./DesktopMenu";
import MobileMenu from "./MobileMenu";
import { CatalogService } from "../services/catalog-service";
import LanguageDetector from '../i18n/language-detector';
import { fetchGuestEmail, removeGuestEmail } from "../services/helper-service";

declare type HeaderState = {
    isLoggedIn: boolean;
    userName?: string;
}
export default class Header extends React.Component<{}, HeaderState> {
    mobileMenu = React.createRef<MobileMenu>();
    readonly enableTranslation: boolean;
    constructor(props: {}) {
        super(props);
        this.state = { isLoggedIn: false };
        const tags = document.getElementsByName("eto:translate");
        this.enableTranslation = tags.length !== 1 ? true : (tags[0] as HTMLMetaElement).content === "true";
    }
    componentWillReceiveProps(nextProps: { history: H.History }) {
    }
    onLogin = () => {
        if (this.mobileMenu.current) this.mobileMenu.current.closeMenu();
        const history = createHashHistory();
        if (history.location.pathname === "/topup") {
            dialogService.showComponent(LoginWithAnalytics, { path: "/login", hash: "auth", animation: "slide-down", style: { bottom: 0, right: 0 }, showCloseButton: true })
                .then(response => {
                    if (response.cancelled) return;
                    this.attachSessionToLoggedInUser();
                    // const guestEmail = fetchGuestEmail();
                    // if (guestEmail) {
                    //     // removeGuestEmail();
                    //     const query = history.location.search;
                    //     const params = new URLSearchParams(query);
                    //     if (params) {
                    //         const sessionId = params.get("sid");
                    //         if (sessionId) {
                    //             // attach Session to the logged in user
                    //             AuthService.attachGuestSessionToUser(sessionId).then(response => {
                    //                 if (response.responseCode == 0) {
                    //                     // remove the guest email if the Session is attached to the user sucessfully
                    //                     removeGuestEmail();
                    //                     window.location.reload();
                    //                 }
                    //             });
                    //         }
                    //     }
                    // }
                });
        } else {
            history.push("/login");
        }
    }
    attachSessionToLoggedInUser = () => {
        const guestEmail = fetchGuestEmail();
        if (guestEmail) {
            const history = createHashHistory();
            const query = history.location.search;
            const params = new URLSearchParams(query);
            if (params) {
                const sessionId = params.get("sid");
                if (sessionId) {
                    // attach Session to the logged in user
                    AuthService.attachGuestSessionToUser(sessionId).then(response => {
                        if (response.responseCode == 0) {
                            // remove the guest email if the Session is attached to the user sucessfully
                            removeGuestEmail();
                            window.location.reload();
                        }
                    });
                }
            }
        }
    }

    onRegister = () => {
        if (this.mobileMenu.current) this.mobileMenu.current.closeMenu();
        const history = createHashHistory();
        if (history.location.pathname === "/topup") {
            // this.setState({ showMenu: false });
            dialogService.showComponent(RegisterWithAnalytics, { path: "/register", hash: "auth", animation: "slide-down", style: { bottom: 0, right: 0 }, showCloseButton: true })
                .then(response => {
                    if (response.cancelled) return;
                    this.attachSessionToLoggedInUser();
                });
        } else {
            history.push("/register");
        }
    }
    onLogout = () => {
        if (this.mobileMenu.current) this.mobileMenu.current.closeMenu();
        AuthService.logout().then(response => {
            this.setState({ isLoggedIn: false });
            const history = createHashHistory();
            history.push("/topup");
        });
    }
    getUserName = () => {
        const userName = this.state.userName;
        if (!userName) return "";
        const [name] = userName.split("@");
        return `${t.common("hello")}, ${name}`;
    }
    componentDidMount() {
        AuthService.isLoggedIn().then(response => {
            if (response) this.setState({ isLoggedIn: true, userName: response });
            else this.setState({ isLoggedIn: false });
        });
        PubSub.subscribe("AUTH", (topic: string, data: any) => {
            if (data === "LOGIN") {
                AuthService.isLoggedIn().then(response => {
                    if (response) this.setState({ isLoggedIn: true, userName: response });
                    else this.setState({ isLoggedIn: false });
                });
            } else if (data === "LOGOUT") {
                this.setState({ isLoggedIn: false, userName: undefined });
            }
        });
    }
    render() {
        const showDashboard = (CatalogService.isSiteRedemptionPIN() === false || CatalogService.isSiteVodafoneFiji());
        return (
            <React.Fragment>
                {this.renderMenu(showDashboard)}
                {this.renderStorePinMenu(showDashboard)}
            </React.Fragment>
        );
    }

    renderMenu(showDashboard: boolean) {
        if (!showDashboard) return undefined;
        // const logoUrl = "https://www.etopuponline.com/images/pages/etopup-logo.png";
        const lang = LanguageDetector.detect();
        return (
            <div className="header d-flex justify-content-between align-items-center pr-lg-7 pl-lg-7 pr-md-5 pl-md-5 pr-sm-4 pl-sm-4 pr-3 pl-3">
                <a className="logo" href={`/${lang}/`} title="Top Up Mobile Phone Online" />
                <div className="h-100 d-none d-md-flex">
                    <NavLink className="desktop-menu-link" to="/home">
                        <span>{t.menu("dashboard")}</span>
                    </NavLink>
                    <NavLink className="desktop-menu-link" to="/topup">
                        <span>{t.menu("send_balance")}</span>
                    </NavLink>
                    {CatalogService.isSiteETO() &&
                    <NavLink className="desktop-menu-link" to="/giftcard">
                        <span>{t.menu("buy_gift_card")}</span>
                    </NavLink>}{!CatalogService.isSitePosIT() && !CatalogService.isSiteCodesDirect() && 
                    <NavLink className="desktop-menu-link" to="/auto-topups">
                        <span>{t.menu("auto_balance")}</span>
                    </NavLink>}
                </div>
                {!this.state.isLoggedIn && <div className="d-none d-md-flex justify-content-end align-items-center flex-fill">
                    <a className="desktop-menu-button white" onClick={this.onLogin}>{t.menu("login")}</a>
                    <a className="desktop-menu-button blue ml-1" onClick={this.onRegister}>{t.menu("register")}</a>
                </div>}
                {this.state.isLoggedIn && <DesktopMenu userName={this.getUserName()} onLogoutClicked={this.onLogout} />}
                {this.enableTranslation && <LanguageMenu textColor="#fff" isMobile={false} isLoggedIn={this.state.isLoggedIn} />}
                <MobileMenu ref={this.mobileMenu} isLoggedIn={this.state.isLoggedIn}
                    onLogin={this.onLogin} onLogout={this.onLogout}
                    onRegister={this.onRegister}
                    getUserName={this.getUserName}
                    showDashboard={showDashboard}
                />
            </div>
        );
    }
    renderStorePinMenu(showDashboard: boolean) {
        if (showDashboard) return undefined;
        const lang = LanguageDetector.detect();
        return (
            <div className="header d-flex justify-content-between align-items-center pr-lg-7 pl-lg-7 pr-md-5 pl-md-5 pr-sm-4 pl-sm-4 pr-3 pl-3">
                <a className="logo" href={`/${lang}/`} title="Top Up Mobile Phone Online" />
                <div className="h-100 d-none d-md-flex">
                    <NavLink className="desktop-menu-link" to="/topup">
                        <span>{t.menu("send_balance")}</span>
                    </NavLink>
                </div>
                <div className="d-none d-md-flex justify-content-end align-items-center flex-fill"></div>
                {this.enableTranslation && <LanguageMenu textColor="#fff" isMobile={false} isLoggedIn={this.state.isLoggedIn} />}
                <MobileMenu ref={this.mobileMenu} isLoggedIn={this.state.isLoggedIn}
                    onLogin={this.onLogin} onLogout={this.onLogout}
                    onRegister={this.onRegister}
                    getUserName={this.getUserName}
                    showDashboard={showDashboard}
                />
            </div>
        );
    }
}